export async function shareViaApps({ title = '', text = '', url }) {
  if (!url || typeof window === 'undefined') {
    return;
  }

  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (error) {
      if (error?.name === 'AbortError') {
        return;
      }
    }
  }

  const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(
    text || title || url
  )}`;
  window.open(telegramUrl, '_blank', 'noopener,noreferrer');
}
